import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '~/constants';

import ButtonBase from "@material-ui/core/ButtonBase";
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Icon from '@material-ui/core/Icon';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

import fetch from '~/utils/fetch';

import EnhancedTable from '~/widgets/table-enhanced'
import LinkButton from '~/widgets/button-link'

class Container extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
            is_loaded: false
        }
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.DEPARTMENTS_CLEAR_DETAIL})
        this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ALL})
    }

    render() {
        console.log(this.props);
        console.log(this.state);

        if(!this.props.departments.is_loaded){
            return 'Loading...'  // hide while loading
        }

        let table = '';
        if(this.props.departments.list.length > 0){
            let departments = this.props.departments.list;
            table = <EnhancedTable
                data={departments.map(r=>{
                    return {
                        ...r,
                    }
                })}
                rowsPerPage={10}
                rowClickHandler={(e, r)=>{
                    this.props.history.push(`/app/departments/${r._id}`)
                }}
                columns={[
                  {id: 'vcaInsurerId', label: 'VCA #' },
                  {id: 'name', label: 'Client' },
                  {id: 'branch', label: 'Branch' },
                  {id: 'entityType', label: 'Type' },
                  {id: null, label: 'Address' },
                  {id: null, label: 'Contact' },
                  {id: null, label: 'Actions'}
                ]}
                buildTableRow={(r)=>{
                    let vcaChip = <Chip className={(r.vcaApiError ? 'chip chip-error' : 'chip chip-success')} label={(r.vcaApiError ? 'Error' : r.vcaInsurerId)}/>;
                    if(r.internalOnly === true){
                        vcaChip = <Chip style={{fontSize: '0.55rem'}} className={'chip chip-info'} label={'INTERNAL'}/>;
                    }
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>
                                <Tooltip interactive placement='top' title={(r.vcaApiError ? r.vcaApiError: (r.active ? 'Active' : 'Inactive'))}>
                                    {vcaChip}
                                </Tooltip>
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.name}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.branch}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.entityType}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.address.street}, {r.address.city}, {r.address.state} {r.address.zip}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.contact.firstname} {r.contact.lastname} ({r.contact.email})</EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <Link to={`/app/departments/${r._id}`}>
                                    <Icon>edit</Icon>
                                </Link>
                            </EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        }

        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <h1>Clients</h1>
                    </div>
                    <div className="page-actions">
                        <LinkButton to={`/app/departments/create`} className="button button-primary button-wide">
                            Add Client
                        </LinkButton>
                    </div>
                </div>
                <div className="card card-table">
                    {table}
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            departments: state.departments,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);